import * as jsrsasign from "jsrsasign";
/**
 * Public key to use for verifying the license token's signature.
 */

var PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----" + "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0Ooa70GApbw3uV7xFOTP" + "2kiXftbpRTZNgWUEMmbRDh0TratGUBEFPV+/f3DGTOBBw2zmwyf+vDe6k6ekhKII" + "wmwsSSKU3d1hqoM/ETtwU9eHwyEbf75jZcT25BHW/k2nMxg6gkqWAyBYXa1a0FLH" + "Nko1V+ltwvlHKF8CChEpAw+Jmg53V9AFxWMslZKp7AyBlqYkVqO+ydOfFRrGJWTF" + "ez/0IBFoCqOZdxRubGGNeOqjq/clgTGlbjWJF7kAS8o0+W2hr7yWkBrZ1K7qvC+D" + "W+bb6nfiFnuvdjUwTwGa3Qp5t2EXbMv7MFZraqWaS0fh9I4VmrODDyoXMe4uSuMn" + "WQIDAQAB" + "-----END PUBLIC KEY-----";
var TOKEN_VERSION = "2.0";

var TokenInspector =
/** @class */
function () {
  function TokenInspector(logger) {
    this._logger = logger;
  }
  /**
   * Parsed the token and returns the payload of the JWT token.
   * @param token ILicenseToken instance
   */


  TokenInspector.prototype.Parse = function (jwtToken) {
    var jwtParts = jwtToken.split(".");
    var payload = JSON.parse(atob(jwtParts[1]));
    return payload;
  };
  /**
   * Validates the specified jwt token
   * @param jwtToken Jwt token
   * @param expirationTime Expiration time of token
   */


  TokenInspector.prototype.Validate = function (jwtToken, expirationTime) {
    var isValid = jsrsasign.jws.JWS.verify(jwtToken, PUBLIC_KEY, ["RS256"]);

    if (isValid) {
      this._logger.LogInfo("Signature of token is valid. Checking expiration of token...");

      if (Date.now() < expirationTime) {
        this._logger.LogInfo("Token is not expired.");

        var parsedToken = this.Parse(jwtToken);

        if (!parsedToken.ver || parsedToken.ver !== TOKEN_VERSION) {
          this._logger.LogInfo("Token is deprecated. A new token needs to be requested to support version " + TOKEN_VERSION);

          return false;
        }

        return true;
      } else {
        this._logger.LogInfo("Token is expired.");
      }
    } else {
      this._logger.LogInfo("Signature of token is not valid.");
    }

    return false;
  };

  return TokenInspector;
}();

export { TokenInspector };